<!-- ========================================================= -->
<!-- PROCESO INTERRUMPIDO -->
<!-- ========================================================= -->

<div *ngIf="timeoutSocketProgress" class="process-alert process-alert-warning" role="alert">
  <div class="process-alert-icon">
    <i class="fa-solid fa-triangle-exclamation"></i>
  </div>

  <div class="process-alert-content">
    <h6>Proceso interrumpido</h6>

    <p>
      No se ha recibido respuesta del proceso de firma en el tiempo esperado.
      Es posible que haya ocurrido un problema durante la ejecución.
    </p>

    <p>
      Puedes cancelar el lote actual e intentar nuevamente.
    </p>

    <div class="process-alert-actions">

      <button type="button" class="btn-soft-danger" (click)="restaurarFirma()" [disabled]="restaurarIsLoagin">
        <i *ngIf="restaurarIsLoagin" class="fa-solid fa-spinner fa-spin"></i>

        <i *ngIf="!restaurarIsLoagin" class="fa-solid fa-xmark"></i>

        Cancelar proceso
      </button>

      <button type="button" class="btn-soft-primary" (click)="reload()">
        <i class="fa-solid fa-arrows-rotate"></i>
        Intentar reconectar
      </button>

    </div>
  </div>
</div>


<!-- ========================================================= -->
<!-- FIRMA REALIZADA -->
<!-- ========================================================= -->

<div class="result-container" *ngIf="
    (id_lote_estado_certificado == 7 && firmaGrupalIndividualCompletado) ||
    (id_lote_estado_certificado == 3 || firmaGrupalIndividualCompletado)
  ">

  <div class="result-card">

    <div class="result-animation">
      <lottie-player src="/assets/lottie/contractsign.json" background="transparent" speed="0.5" loop autoplay>
      </lottie-player>
    </div>

    <div class="result-content">

      <span class="result-badge result-badge-success">
        <i class="fa-solid fa-circle-check"></i>
        Proceso completado
      </span>

      <h2>Firma realizada</h2>

      <p>
        El documento ha sido firmado exitosamente.
      </p>

    </div>


    <div class="action-buttons">

      <button class="custom-btn primary-btn" (click)="descargarDocumento('Mi documento')" *ngIf="!firmaFinalizada">
        <i class="fa-solid fa-download"></i>

        <span>
          Descargar documento
        </span>
      </button>


      <button class="custom-btn share-btn" *ngIf="!firmaFinalizada && isDiviceType"
        (click)="compartirPdf('Mi documento')">
        <i class="fa-solid fa-share-nodes"></i>

        <span>
          Compartir documento
        </span>
      </button>


      <button class="custom-btn home-btn" (click)="volverInicio()">
        <i class="fa-solid fa-house"></i>

        <span>
          Volver al inicio
        </span>
      </button>

    </div>

  </div>

</div>


<!-- ========================================================= -->
<!-- LOTE CREADO -->
<!-- ========================================================= -->

<div class="result-container" *ngIf="id_lote_estado_certificado != 3 && !creator">

  <div class="result-card">

    <div class="result-animation">
      <lottie-player src="/assets/lottie/success2.json" background="transparent" speed="0.5" loop autoplay>
      </lottie-player>
    </div>

    <div class="result-content">

      <span class="result-badge result-badge-success">
        <i class="fa-solid fa-circle-check"></i>
        Sobre creado
      </span>

      <h2>¡Felicidades! Sobre creado</h2>

      <p>
        El sobre está a la espera de ser firmado por los participantes.
      </p>

    </div>


    <div class="result-single-action">

      <button class="custom-btn back-btn" (click)="volverInicio()">
        <i class="fa-solid fa-house"></i>
        Volver al inicio
      </button>

    </div>

  </div>

</div>


<!-- ========================================================= -->
<!-- DOCUMENTOS CON PROBLEMAS -->
<!-- ========================================================= -->

<div class="result-container" *ngIf="idStatusSigner">

  <div class="result-card">

    <div class="result-animation">
      <lottie-player src="/assets/lottie/loading.json" background="transparent" speed="0.5" loop autoplay>
      </lottie-player>
    </div>


    <div class="result-content">

      <span class="result-badge result-badge-warning">
        <i class="fa-solid fa-clock"></i>
        Procesando
      </span>

      <h2>
        Algunos documentos no pudieron procesarse correctamente
      </h2>

      <p>
        Durante la firma realizada por
        <strong>{{ scratch.nombre }}</strong>
        se detectaron documentos pendientes.
      </p>

      <p>
        Aguarda un momento. La persona responsable ya ha sido notificada.
      </p>

    </div>


    <div class="result-single-action">

      <button class="custom-btn back-btn" (click)="volverInicio()">
        <i class="fa-solid fa-house"></i>
        Volver al inicio
      </button>

    </div>

  </div>

</div>


<!-- ========================================================= -->
<!-- FORMULARIO PRINCIPAL DE FIRMA -->
<!-- ========================================================= -->

<div class="signature-page" *ngIf="
    (id_lote_estado_certificado != 3 &&
      !firmaGrupalIndividualCompletado &&
      creator &&
      !idStatusSigner &&
      !timeoutSocketProgress) ||
    (id_lote_estado_certificado == 7 &&
      !firmaGrupalIndividualCompletado &&
      !timeoutSocketProgress)
  ">

  <div data-tour="firmar-documento-root">


    <!-- ===================================================== -->
    <!-- CARD PRINCIPAL -->
    <!-- ===================================================== -->

    <div>


      <!-- =================================================== -->
      <!-- HEADER -->
      <!-- =================================================== -->

      <div class="signature-header">

        <div class="signature-header-info">

          <!-- <div class="signature-header-icon">
            <i class="fa-solid fa-file-signature"></i>
          </div> -->

          <!-- <div>
            <h3>
              Firmar documento
            </h3>

            <p>
              Selecciona tu certificado e ingresa las credenciales
              necesarias para completar la firma.
            </p>
          </div> -->

        </div>


        <div class="signature-header-actions">

          <button type="button" class="document-btn" id="btnDocument"
            (click)="openModal(openDocuments, 'Ver documentos', 'xl')" data-tour="btn-previsualizar-documento">
            <i class="fa-solid fa-file-pdf"></i>

            <span>
              Ver documento
            </span>
          </button>


          <button type="button" class="help-btn" (click)="onHelp(true)" aria-label="Ayuda" title="Ayuda">
            <i class="fa fa-info"></i>
          </button>

        </div>

      </div>


      <!-- =================================================== -->
      <!-- CONFIGURACIÓN DE FIRMA -->
      <!-- =================================================== -->

      <div class="signature-section">

        <!-- <div class="section-title-row">

          <div>
            <h5>
              Configuración de firma
            </h5>

            <p>
              Selecciona cómo deseas realizar la firma.
            </p>
          </div>

        </div> -->


        <!-- ================================================= -->
        <!-- FIRMA CON IMAGEN -->
        <!-- ================================================= -->

        <div class="custom-toggle-card">

          <div class="toggle-content" data-tour="toggle-firmar-con-imagen">

            <div class="toggle-icon">
              <i class="fa-solid fa-image"></i>
            </div>


            <div class="toggle-info">

              <span class="toggle-title">
                Firma con imagen
              </span>

              <span class="toggle-description">
                Permite utilizar una imagen personalizada para firmar.
              </span>

            </div>


            <label class="modern-switch">

              <input id="checkFirmaImgen" type="checkbox" [(ngModel)]="firmaConImagenLote"
                [ngModelOptions]="{ standalone: true }" (ngModelChange)="onChangeFirmaImagen($event)" />

              <span class="slider"></span>

            </label>

          </div>


          <!-- =============================================== -->
          <!-- CERTIFICADOS -->
          <!-- =============================================== -->

          <div class="certificate-selector" *ngIf="certificados?.length">

            <div class="certificate-selector-header">

              <span>
                Certificado para firmar
              </span>

              <small>
                Selecciona el certificado que deseas utilizar
              </small>

            </div>


            <div class="scratch-container" data-tour="btn-cambio-scratchcard">

              <div class="scratch-card" *ngFor="let item of certificados" [ngClass]="{
                  'selected':
                    changeScratchForm.value.id_certificado === item.id,
                  'disabled':
                    changeScratchForm.value.id_certificado === item.id
                }" (click)="onNewCertificadoChange(item)">

                <!-- CHECK -->

                <div class="scratch-selection">

                  <div class="scratch-radio" [class.active]="
                      changeScratchForm.value.id_certificado === item.id
                    ">
                    <i *ngIf="
                        changeScratchForm.value.id_certificado === item.id
                      " class="fa-solid fa-check"></i>
                  </div>

                </div>


                <!-- ICONO -->

                <div class="scratch-icon">
                  <i class="fa-solid fa-id-card"></i>
                </div>


                <!-- INFORMACIÓN -->

                <div class="scratch-content">

                  <div class="scratch-header">
                    {{ item.nombre }}
                  </div>

                  <div class="scratch-body">
                    {{ item?.tipoCertificado.nombre }}
                  </div>

                  <div class="scratch-number">
                    {{ item.scratchcard }}
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>


      <!-- =================================================== -->
      <!-- CREDENCIALES -->
      <!-- =================================================== -->

      <form [formGroup]="solicitudForm" class="signature-form">

        <div class="signature-section">

          <!-- <div class="section-title-row">

            <div>
              <h5>
                Credenciales de firma
              </h5>

              <p>
                Verifica el certificado e ingresa tus credenciales.
              </p>
            </div>

          </div> -->


          <!-- ================================================= -->
          <!-- NUEVO NOMBRE -->
          <!-- ================================================= -->

          <div class="form-field" *ngIf="renombrarDocumentos && perGrupo">

            <label>
              Nuevo nombre de documento
            </label>

            <div class="modern-input">

              <i class="fa-solid fa-file-pen input-icon"></i>

              <input type="text" class="form-control" formControlName="nuevo_nombre_documento"
                placeholder="Nombre del documento" />

            </div>


            <app-error-message [control]="solicitudForm.get('nuevo_nombre_documento')" errorKey="required"
              message="El nuevo nombre de documento es requerido">
            </app-error-message>

          </div>


          <!-- ================================================= -->
          <!-- DATOS DEL CERTIFICADO -->
          <!-- ================================================= -->

          <div class="certificate-data-grid">


            <!-- SCRATCHCARD -->

            <div class="form-field">

              <label>
                Scratchcard
              </label>

              <div class="modern-input readonly-input">

                <i class="fa-solid fa-id-card input-icon"></i>

                <input type="text" class="form-control" formControlName="scratchcard" placeholder="Ingrese scratchcard"
                  readonly />

              </div>


              <app-error-message [control]="solicitudForm.get('scratchcard')" errorKey="required"
                message="El scratchcard es obligatorio">
              </app-error-message>


              <app-error-message [control]="solicitudForm.get('scratchcard')" errorKey="certificadoVencido"
                message="El certificado seleccionado se encuentra vencido o desactivado. Es necesario elegir otro certificado válido para poder continuar con el proceso de firma.">
              </app-error-message>

            </div>


            <!-- PERTENECIENTE -->

            <div class="form-field">

              <label>
                Perteneciente
              </label>

              <div class="modern-input readonly-input">

                <i class="fa-solid fa-user input-icon"></i>

                <input type="text" class="form-control" formControlName="perteneciente" readonly />

              </div>

            </div>


            <!-- TIPO -->

            <div class="form-field">

              <label>
                Tipo de certificado
              </label>

              <div class="modern-input readonly-input">

                <i class="fa-solid fa-certificate input-icon"></i>

                <input type="text" class="form-control" formControlName="tipo_certificado" readonly />

              </div>

            </div>

          </div>


          <!-- ================================================= -->
          <!-- SEGURIDAD -->
          <!-- ================================================= -->

          <div class="security-box">



            <div class="security-header">

              <div class="security-icon">
                <i class="fa-solid fa-lock"></i>
              </div>

              <div>
                <h6>
                  Seguridad
                </h6>

                <p>
                  Ingresa la contraseña y PIN de tu certificado.
                </p>
              </div>

            </div>

            <!-- =============================================== -->
            <!-- OPCIONES DE CREDENCIALES -->
            <!-- =============================================== -->

            <div class="credential-options">


              <!-- RECORDAR PASSWORD -->

              <div class="credential-option">

                <div>

                  <span class="credential-title">
                    Recordar contraseña
                  </span>

                  <small>
                    Mantiene la contraseña durante el proceso.
                  </small>

                </div>


                <label class="modern-switch small-switch">

                  <input type="checkbox" [(ngModel)]="recordarPassword" [ngModelOptions]="{ standalone: true }" />

                  <span class="slider"></span>

                </label>

              </div>


              <!-- AUTOCOMPLETAR -->

              <div class="credential-option" *ngIf="ocultarFirmaGuardada">

                <div>

                  <span class="credential-title">
                    Autocompletar credenciales
                  </span>

                  <small>
                    Utiliza las credenciales guardadas.
                  </small>

                </div>


                <label class="modern-switch small-switch">

                  <input type="checkbox" [(ngModel)]="firmaGuardada" [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onChangeFirmaGuardada()" />

                  <span class="slider"></span>

                </label>

              </div>

            </div>


            <div class="security-fields">


              <!-- PASSWORD -->

              <div class="form-field">

                <label>
                  Contraseña
                </label>

                <div class="modern-input">

                  <i class="fa-solid fa-key input-icon"></i>

                  <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password"
                    placeholder="Ingrese contraseña" [readonly]="firmaGuardada" />


                  <button type="button" class="visibility-btn" (click)="togglePasswordVisibility()">
                    <i class="fa-solid" [ngClass]="
                        showPassword
                          ? 'fa-eye-slash'
                          : 'fa-eye'
                      "></i>
                  </button>

                </div>


                <app-error-message [control]="solicitudForm.get('password')" errorKey="required"
                  message="El password es obligatorio">
                </app-error-message>

              </div>


              <!-- PIN -->

              <div class="form-field">

                <label>
                  PIN
                </label>

                <div class="modern-input">

                  <i class="fa-solid fa-shield-halved input-icon"></i>

                  <input [type]="showPin ? 'text' : 'password'" class="form-control" formControlName="pin"
                    placeholder="Ingrese PIN" />


                  <button type="button" class="visibility-btn" (click)="togglePinVisibility()">
                    <i class="fa-solid" [ngClass]="
                        showPin
                          ? 'fa-eye-slash'
                          : 'fa-eye'
                      "></i>
                  </button>

                </div>


                <app-error-message [control]="solicitudForm.get('pin')" errorKey="required"
                  message="El pin es obligatorio">
                </app-error-message>

              </div>

            </div>
          </div>

        </div>


        <!-- ================================================= -->
        <!-- FOOTER -->
        <!-- ================================================= -->

        <div class="signature-footer">

          <div class="security-note">

            <i class="fa-solid fa-shield-halved"></i>

            <span>
              Tus credenciales se utilizan únicamente para completar
              el proceso de firma.
            </span>

          </div>


          <button type="submit" class="sign-btn" [disabled]="
              solicitudForm.invalid ||
              btnGuardarIsDisabled ||
              id_lote_estado_certificado == 7
            " (click)="guardar()" data-tour="btn-firmar">

            <i *ngIf="
                btnGuardarIsDisabled ||
                id_lote_estado_certificado == 7
              " class="fa-solid fa-spinner fa-spin"></i>

            <i *ngIf="
                !btnGuardarIsDisabled &&
                id_lote_estado_certificado != 7
              " class="fa-solid fa-file-signature"></i>

            <span>
              Firmar documento
            </span>

          </button>

        </div>

      </form>

    </div>


    <!-- ===================================================== -->
    <!-- RECONECTANDO -->
    <!-- ===================================================== -->

    <div class="reconnecting" *ngIf="
        !progressBarIsVisible &&
        id_lote_estado_certificado == 7 &&
        !firmaGrupalIndividualCompletado
      ">

      <div class="reconnecting-spinner">
        <i class="fa-solid fa-spinner fa-spin"></i>
      </div>

      <div>
        <strong>Reconectando</strong>
        <span>Esperando respuesta del proceso de firma...</span>
      </div>

    </div>


    <!-- ===================================================== -->
    <!-- PROGRESO -->
    <!-- ===================================================== -->

    <div class="signature-progress" id="progressBar" *ngIf="progressBarIsVisible">

      <div class="progress-info">

        <div>

          <span class="progress-title">
            Procesando firma
          </span>

          <small>
            No cierres esta ventana mientras finaliza el proceso.
          </small>

        </div>


        <strong>
          {{ progress }}%
        </strong>

      </div>


      <ngb-progressbar [value]="progress" [max]="100" [striped]="true" [animated]="true" type="info"
        [showValue]="false">
      </ngb-progressbar>

    </div>

  </div>

</div>


<!-- ========================================================= -->
<!-- MODAL CAMBIAR SCRATCHCARD -->
<!-- ========================================================= -->

<ng-template #changeScratch let-modal>

  <div class="modal-header modern-modal-header">

    <div>

      <h5 class="modal-title">
        Cambiar certificado
      </h5>

      <p>
        Selecciona el certificado que deseas utilizar.
      </p>

    </div>


    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    </button>

  </div>


  <div class="modal-body modern-modal-body">

    <form [formGroup]="changeScratchForm">

      <div class="form-field">

        <label>
          Scratchcard
        </label>

        <ng-select formControlName="id_certificado" [items]="certificados" bindValue="id"
          placeholder="Seleccione el nuevo scratchcard" [searchable]="true" [clearable]="true"
          (change)="onNewCertificadoChange($event)">

          <ng-template ng-label-tmp let-item="item">

            <span *ngIf="item && item.nombre">
              {{ item.nombre }} - {{ item.scratchcard }}
            </span>

          </ng-template>


          <ng-template ng-option-tmp let-item="item">

            {{ item.nombre }} - {{ item.scratchcard }}

          </ng-template>

        </ng-select>


        <app-error-message [control]="changeScratchForm.get('id_certificado')" errorKey="required"
          message="El scratchcard es obligatorio">
        </app-error-message>

      </div>

    </form>

  </div>


  <div class="modal-footer modern-modal-footer">

    <button type="button" class="btn-modal-primary" (click)="putCertificado()" [disabled]="btnUpdateScratchIsDisabled">
      <i class="fa-solid fa-check"></i>
      Cambiar certificado
    </button>


    <button type="button" class="btn-modal-secondary" (click)="modal.close('Save click')">
      Cerrar
    </button>

  </div>

</ng-template>


<!-- ========================================================= -->
<!-- MODAL DOCUMENTOS -->
<!-- ========================================================= -->

<ng-template #openDocuments let-modal>

  <div class="modal-header modern-modal-header">

    <div>

      <h5 class="modal-title">
        Documento a firmar
      </h5>

      <p>
        Previsualiza el documento antes de realizar la firma.
      </p>

    </div>


    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    </button>

  </div>


  <div class="modal-body document-modal-body">

    <asociacion-firma-documento [readonly]="true">
    </asociacion-firma-documento>

  </div>


  <div class="modal-footer modern-modal-footer">

    <button type="button" class="btn-modal-secondary" (click)="modal.close('Save click')">
      Cerrar
    </button>

  </div>

</ng-template>